export var compKey = 'profile';
//# sourceMappingURL=key.js.map